const I18N = {
  en: {
    buttonLabel:
      'Press the SPACEBAR to expand or the escape key to collapse this menu. Use the Up and Down arrow keys to choose a submenu item. Press the Enter or Right arrow key to expand it, or the Left arrow or Escape key to collapse it. Use the Up and Down arrow keys to choose an item on that level and the Enter key to access it.',
    menuLabelFull: 'Main menu',
    menuLabelHidden: 'Main ',
    menuToggle: 'Menu',
  },
  fr: {
    buttonLabel:
      "Appuyez sur la barre d'espacement pour ouvrir ou sur la touche d'échappement pour fermer le menu. Utilisez les flèches haut et bas pour choisir un élément de sous-menu. Appuyez sur la touche Entrée ou sur la flèche vers la droite pour le développer, ou sur la flèche vers la gauche ou la touche Échap pour le réduire. Utilisez les flèches haut et bas pour choisir un élément de ce niveau et la touche Entrée pour y accéder.",
    menuLabelFull: 'Menu principal',
    menuLabelHidden: ' principal',
    menuToggle: 'Menu',
  },
};

export default I18N;
